import React from 'react';
import { MDBBtn, MDBCol, MDBContainer, MDBRow, MDBTypography } from 'mdbreact';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Post.scss";
import EX1 from "./../../../assets/images/female/ex1.png";
import EX2 from "./../../../assets/images/female/ex2.png";

const Post = (props: PostProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.homepage
    );

    return <MDBRow className="post">
        <MDBCol sm="12">
            <h3 className="text-center mb-1">{dictionary?.articles_and_tips}</h3>
        </MDBCol>
        <MDBCol sm="12" className="mt-3">
            <MDBContainer>
                <MDBRow center middle>
                    <MDBCol xs="12" sm="12" md="12" >
                        <section className="item">
                            <img src={EX1} alt="" />
                            <h6>عنوان رقم1</h6>
                            <p>
                                11-اكتوبر-2021
                            </p>
                        </section>
                    </MDBCol>
                    <MDBCol xs="12" sm="12" md="12" >
                        <section className="item">
                            <img src={EX2} alt="" />
                            <h6>عنوان رقم1</h6>
                            <p>
                                11-اكتوبر-2021
                            </p>
                        </section>
                    </MDBCol>
                    <MDBCol sm="12">
                        <MDBBtn outline>
                            {dictionary?.more_post}
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBCol>
    </MDBRow>
};

interface PostProps { }
export default Post;